// Module
var code = "<div class=\"bar-wrapper\"> <div class=\"bar-background\"> <div class=\"bar\" ng-style=\"$ctrl.barStyle\"> <div class=\"bar-text\"></div> </div> <div class=\"bar unfiltered-bar\" ng-if=\"$ctrl.unfilteredValue\" ng-style=\"$ctrl.unfilteredBarStyle\"></div> </div> <div class=\"bar-text\">{{ $ctrl.value | number }}</div> </div> ";
// Exports
export default code;